export const lightTheme = {
  token: {
    colorPrimary: "#0DC939",
    colorSuccess: "#52c41a",
    colorWarning: "blue",
    colorError: "blue",
    colorInfo: "blue",
    colorTextBase: "rgba(0, 0, 0, 0.85)",
    bgContainer: "#ffffff",
    btnBackground: "#ffffff",
    headingTextColor: "#344138",
    footerBackground: "#354138",
    text: "#000",
    text2: "#CCCCCC",
    text3: "#fff",
    borderRadius: 6,
    wireframe: false,
  },
  components: {
    Button: {
      primaryShadow: "0 2px 0 rgba(5, 48, 89, 0.045)",
    },
    Card: {
      padding: 20,
    },
  },
};

export const darkTheme = {
  token: {
    colorPrimary: "#07A12E",
    colorSuccess: "#52c41a",
    colorWarning: "#faad14",
    colorError: "#ff4d4f",
    colorInfo: "#1f1f1f",
    colorTextBase: "rgba(255, 255, 255, 0.85)",
    bgContainer: "#181A1B",
    btnBackground: "#181A1B",
    headingTextColor: "#ffffff",
    footerBackground: "#111314",
    text: "#ffffff",
    text2: "#444",
    text3: "#000",
    borderRadius: 6,
    wireframe: false,
  },
  components: {
    Button: {
      primaryShadow: "0 2px 0 rgba(0, 0, 0, 0.045)",
    },
    Card: {
      padding: 20,
    },
  },
};
